import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import AutoComplete from './AutoComplete'
import { useGetIscrizioniQuery } from '../hooks/api-slice'
import { sortNumerically, sortGironi } from '../hooks/sort-functions'
import { groupByGirone } from '../hooks/utils-functions'
import { titlesCalendari } from '../settings/settings'

const DialogRipescaggio = ({ open, handleClose, triggerFunction, gara }) => {
  const { data: squadre = [] } = useGetIscrizioniQuery(
    { campionato: gara?.codiceCampionato, categoria: gara?.categoria },
    { skip: !(gara?.codiceCampionato && gara?.categoria) },
  )

  const [ripescaggioID, setRipescaggioID] = useState()

  useEffect(() => {
    setRipescaggioID()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(ripescaggioID)}
      title={titlesCalendari.titleEditRipescaggio}
      textConfirm='Salva'
    >
      {!gara ? (
        <Grid size={12}>Nessuna partita selezionata.</Grid>
      ) : (
        <Grid size={12}>
          <AutoComplete
            id='ripescaggio'
            value={ripescaggioID}
            label='Squadra da ripescare'
            options={[...squadre]?.sort(
              (a, b) =>
                sortGironi(a.girone, b.girone) ||
                sortNumerically(a.posizione, b.posizione),
            )}
            groupBy={groupByGirone}
            getOptionLabel={op =>
              squadre?.find(i => i?.id === (op?.id || op))?.nomeSquadra
            }
            isOptionEqualToValue={(op, value) => op?.id === value}
            onChange={value => setRipescaggioID(value?.id)}
          />
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogRipescaggio
